import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';
import PhoneNumber from 'awesome-phonenumber';
import * as _ from 'lodash';

import {
  ticketContactDataSelector,
  ticketCreatedAtSelector,
  ticketPreviousTicketsSelector,
  ticketShowPreviousTicketsSelector,
} from '@/redux/app/selectors/ticket';
import { togglePreviousTickets } from '@/redux/app/actions/ticket';
import { PreviousTicketItem } from './PreviousTicketItem';

export interface PreviousTicketsProps {
  ticket: string;
}

const PreviousTicketListWrapper = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')} !important
`;

export const PreviousTickets = ({ ticket }: PreviousTicketsProps) => {
  const previousTickets = useSelector(_.partial(ticketPreviousTicketsSelector, ticket));
  const ticketCreatedAt = useSelector(_.partial(ticketCreatedAtSelector, ticket));
  const contactData = useSelector(_.partial(ticketContactDataSelector, ticket));
  const showPreviousTickets = useSelector(_.partial(ticketShowPreviousTicketsSelector, ticket));

  const displayName = contactData?.display_name === contactData?.phone
    ? contactData?.phone && new PhoneNumber(contactData?.phone)
    : (contactData?.display_name);

  const dispatch = useDispatch();
  const handleToggle = useCallback(() => {
    dispatch(togglePreviousTickets(ticket));
  }, [ticket, dispatch]);

  if (!previousTickets) return null;
  if (previousTickets.length < 1) {
    return (
      <div id="convo-beginning" className="container">
        <div className="content">
          This is the beginning of your history with
          <span>
            {displayName instanceof PhoneNumber
              ? `+${displayName.getCountryCode()} ${displayName.getNumber('national')}`
              : (displayName ?? 'Restricted')}
          </span>
          <div className="chat-timestamp">
            {ticketCreatedAt && moment(ticketCreatedAt * 1000).format('L [AT] LT')}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="sibling-convos" className="container">
      <div className="prev-convos-container">
        <button
          type="button"
          className="prev-text-container"
          onKeyPress={handleToggle}
          onClick={handleToggle}
        >
          {`${showPreviousTickets ? 'Hide' : 'Show'} Previous Conversations`}
        </button>
        <PreviousTicketListWrapper className="prev-convos-wrap" show={showPreviousTickets}>
          {previousTickets.map((uuid) => <PreviousTicketItem key={uuid} uuid={uuid} />)}
        </PreviousTicketListWrapper>
      </div>
    </div>
  );
};
